import { render, staticRenderFns } from "./appointmentDuration.vue?vue&type=template&id=a9501ac4&scoped=true&"
import script from "./appointmentDuration.vue?vue&type=script&lang=js&"
export * from "./appointmentDuration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9501ac4",
  null
  
)

export default component.exports